import React from 'react'
import './confirmStyles.scss'

const ConfirmModal = (props) => {
  const {t} = props
  const {
    title = t('ducs.confirm_deletion'),
    handleCloseModal,
    handleConfirmModal,
    cancelText = t('ducs.cancel'),
    confirm = t('ducs.ok'),
    text = t('ducs.sure_to_remove_file')
  } = props

  return (
      <div className='confirm-modal-wrapper'>
        <div className='title'>{title}</div>
        <div className="bodyWrapper">
          <div className="text">{text}</div>
          <div className="buttonsWrapper">
            <button className="button" onClick={handleConfirmModal}>{confirm}</button>
            <button className="button cancelButton" onClick={handleCloseModal}>{cancelText}</button>
          </div>
        </div>
      </div>
  )
}

export default ConfirmModal
